import { render, staticRenderFns } from "./termly_report.vue?vue&type=template&id=618e0c56&scoped=true&"
import script from "./termly_report.vue?vue&type=script&lang=js&"
export * from "./termly_report.vue?vue&type=script&lang=js&"
import style0 from "./termly_report.vue?vue&type=style&index=0&id=618e0c56&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "618e0c56",
  null
  
)

export default component.exports